(() => {
  const init = root => {
    const popup = root.querySelector('[data-dress-welcome]');
    if (!popup || popup.dataset.initialized) return;
    popup.dataset.initialized = 'true';
    const seenKey = 'tenlove:dress:auto-sale:welcome:v1';
    let timer;
    const seen = () => {
      try { return sessionStorage.getItem(seenKey) === 'seen'; }
      catch { return false; }
    };
    const remember = () => {
      clearTimeout(timer);
      try { sessionStorage.setItem(seenKey, 'seen'); } catch {}
    };
    const close = () => popup.close();
    const open = () => {
      if (!root.isConnected || popup.open || document.querySelector('dialog[open]')) return;
      const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
      const variant = variants.find(v => String(v.id) === root.querySelector('[data-id]').value);
      const money = cents => new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency', currency:root.dataset.currency || 'USD'}).format(cents / 100);
      if (variant) {
        popup.querySelector('[data-welcome-now]').textContent = money(variant.price);
        const was = popup.querySelector('[data-welcome-was]');
        was.hidden = !(variant.compareAt > variant.price);
        was.textContent = money(variant.compareAt);
      }
      popup.showModal();
      document.documentElement.classList.add('tld-welcome-lock');
      remember();
    };
    root.querySelector('[data-welcome-open]')?.addEventListener('click', open);
    popup.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', close));
    popup.addEventListener('close', () => {
      document.documentElement.classList.remove('tld-welcome-lock');
      remember();
    });
    popup.addEventListener('click', event => {
      const bounds = popup.getBoundingClientRect();
      if (event.target === popup && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) close();
    });
    popup.querySelector('[data-welcome-shop]').addEventListener('click', () => {
      remember();
      close();
    });
    // Avoid interrupting someone already choosing sizes or starting checkout.
    for (const type of ['pointerdown', 'keydown']) root.addEventListener(type, event => {
      if (event.target.closest('[data-dress-form], [data-express], [data-sticky], [data-add]')) remember();
    });
    if (!seen() && !window.Shopify?.designMode) timer = setTimeout(() => {
      if (document.visibilityState === 'visible' && !seen()) open();
    }, 5000);
  };
  document.querySelectorAll('[data-dress]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-dress]').forEach(init));
})();
